<template>
  <div class="detalle">
    <div  v-if="vtex">
<h4 class="items-titulo">
      <i class="icon-detalle"></i> Detalle de productos ({{ vtex.items.length }} items)
    </h4>
    <div class="contenedor-productos" :style="'height:' + height" id="style-1">
      <ul class="data-vtex-ul" >
        <li
          v-for="i in orderBy(vtex.items, 'orden', -1)"
          :key="i.uniqueId"
          :class="getClassItem(i)"
        >
          <!-- <img :src="i.imageUrl" alt="" />  :class="getClassItem(i)" -->
          <el-image :src="i.imageUrl" :fit="'contain'" class="thumbnail">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <p>
            <strong v-if="getRealQuantity(i)">
              {{ i.name ? i.name.toLowerCase() : "" }} <br />
              {{ getRealQuantity(i) }}
              {{ getRealQuantity(i) | pluralize(["unidad", "unidades"]) }}
            </strong>
            <br />
            <span v-if="i.modificado">
              <strong
                style="font-size: 12px; color: #f44336"
                v-if="i.quantity - i.cambios.quantity == 0"
              >
                PRODUCTO ELIMINADO ({{ i.cambios.quantity }}
                {{ i.cambios.quantity | pluralize(["UNIDAD", "UNIDADES"]) }}) POR FALTA DE
                STOCK
              </strong>
              <strong
                style="font-size: 12px; color: #f44336"
                v-if="i.quantity - i.cambios.quantity > 0"
              >
                ENTREGA PARCIAL SE QUITARON {{ i.cambios.quantity }}
                {{ i.cambios.quantity | pluralize(["UNIDAD", "UNIDADES"]) }} DEL PRODUCTO
                POR FALTA DE STOCK
              </strong>
              <br />
            </span>
            <span style="padding: 0px" v-if="i.sellingPrice">
              <strong>Precio: {{ (i.listPrice / 100) | currency }}</strong>
              <span v-if="i.listPrice - i.sellingPrice">
                - Precio con descuento: {{ (i.sellingPrice / 100) | currency }}
              </span>
              <span v-if="i.listPrice - i.sellingPrice">
                - Descuento: {{ getDescuento(i) }}
              </span>
            </span>
            <span v-else>
              <span v-if="i.sellingPrice">
                Precio: {{ (i.sellingPrice / 100) | currency }}
              </span>
              <span v-else> Precio: 0 - Corresponde a promoción 2x1 </span>
            </span>
          </p>
        </li>
      </ul>
    </div>
    <div class="mensaje">
      <strong style="color: #BFBE51">Importante:</strong> los precios son por unidad
    </div>
    </div>
    <div v-loading="!vtex" element-loading-text="Recuperando información" style="margin-top:20vh"  element-loading-spinner="el-icon-loading">

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";
import Vue2Filters from "vue2-filters";
export default {
  props: ["datos"],
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      height: '410px',
      total_pago: 0,
      pedido: this.$route.params.pedido ? this.$route.params.pedido : this.datos.vtex_id,
    };
  },
  computed: {
    ...mapGetters({
      vtex: "dataVtex",
    }),
  },
  created() {
    console.log('datos desde vtex2', this.datos);
    if (this.vtex &&  this.vtex.items.length >= 4 ) {
      this.height = "410px";
    }
    else{
      if(this.$isMobile()){
        this.height = "70vh";
      }
      else{
        this.height =  (this.vtex.items.length * 105).toString() + "px"
      }
    }
 
  },
  methods: {
    ...mapActions({
      vuexLoadDatos: "loadDatos",
      vuexGetDataVtex: "getDataVtex",
    }),
    cerrarModal() {
      EventBus.$emit("cerrarModal", 1);
    },
    getDescuento(i) {
     
      let promos = (this.datos && this.datos.productos.length) ?  
      this.datos.productos.filter(
        p => ((p.articulo == i.id || p.id_kit == i.id) && p.promos )
      )[0] : false;
      let lista = i.listPrice / 100;
      let venta = i.sellingPrice / 100;

      let descuento = 100 - (venta * 100) / lista;
      console.log('PROMO', promos);
      // return false
      if(promos && promos.promos)
      {
        return promos.promos.replace('100%', '');
      }
      else 
      {
        return descuento.toFixed(1) + "%";
      }
      
    },
    getRealQuantity(i) {
      let quantity = 0;

      if (i.cambios && i.cambios.quantity) {
        quantity = i.quantity - i.cambios.quantity;
      } else {
        quantity = i.quantity;
      }

      return quantity;
    },

    getTotalPago(pagos) {
      let total = pagos.map((p) => p.value).reduce((a, b) => a + b);

      return total / 100;
    },
    getClassItem(i) {
      let clase = "";
      if (i.modificado) {
        if (i.quantity - i.cambios.quantity == 0) {
          clase = "item-cambio";
        } else {
          clase = "item-cambio-parcial";
        }
      }

      return clase;
    },
  },
};
</script>

<style lang="scss" scoped>
.detalle {
  position: relative;
  margin: 20px;
}
.mensaje {
  position: absolute;
  top: 450px;
  bottom: 0;
  width: 100%;
  margin-top: 40px;
  // border-top: 1px solid #f1f1f1;
  text-align: left;
  padding: 5px 5px;
  font-size: 13.5px;
  font-weight: bold;
  font-family: 'Montserrat', sans-serif;
}
.contenedor-productos {
  // height: 410px;
  overflow-y: auto;
  overflow-x: hidden;
  // padding-bottom: 20px;

  border: 2px solid #e9e9e9;
  border-radius: 4px;
}
.data-vtex-ul {
  list-style-type: none;
  padding: 0px 25px;
  width: 100%;
  // border: 2px solid #D2D2D2;
  box-sizing: border-box;
  margin: 0;
  overflow: visible;
}

.data-vtex-ul > li {
  display: flex;
  align-items: center;
  padding: 5px 0px;
  border-bottom: 2px solid #e9e9e9;
  margin: 5px;
}
.data-vtex-ul > li:last-child {
  border-bottom: none;
}
.data-vtex-ul > li > p {
  text-transform: capitalize;
  text-align: left;
  word-break: break-word;
  font-size: 13.5px;
  font-weight: 500;
  color: #333;
  line-height: 1.2;
}
i.el-icon-picture-outline {
  font-size: 30px !important;
  display: block;
  margin: 0 auto;
  text-align: center;
  color: #fadedc;
}
.data-vtex-ul > li > img,
.thumbnail {
  width: 46px;

  text-align: center;
  padding: 4px;
  //   border-right:1px solid #ddd;
  margin-right: 15px;
  height: 100%;
}
.items-titulo {
  margin: 0;
  padding: 10px;
  padding-left: 0px;
  padding-bottom: 0px;
  // background: #f1f1f1;
  // width: 100%;
  text-align: left;
  margin-bottom: 5px;
}

.items-retiro {
  margin: 0;
  padding: 20px;
  margin-top: 10px;
  background: #fafafa;
  width: 94.8%;
  text-align: center;
  margin-bottom: 10px;
}
.item-ok {
  border-left: 2px solid #cddc39;
}
.item-cambio {
  // border-left: 2px solid #f44336;
  background: rgb(244 67 54 / 6%);
  
  margin-top: -5px !important;
}
.item-cambio-parcial {
  // border-left: 2px solid #f4ce36;
  background: rgb(255 235 59 / 15%);
 
  margin-top: -5px !important;

}
.table-items > tr > th {
  padding: 3px 10px;
}
@media screen and (max-width: 768px) {
  .mensaje {
  
  top: 75vh;
  
}
  .detalle {
    position: relative;
    margin: 5px 3px;
    margin-bottom: 120px;
  }
  .data-vtex-ul {
    padding: 0px 0px;
  }

  .data-vtex-ul > li > img,
.thumbnail {
  width: 120px;

  text-align: left;
  padding: 0px;
  //   border-right:1px solid #ddd;
  margin-right: 10px;
  height: 100%;
}
}
</style>
